



import React, { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
import "./Certificate.css";

const Certificate = ({ generatedCertificate }) => {
  const { employeeName, course, startDate, endDate, certificateId,cinId } = generatedCertificate
  console.log(certificateId,"id")
  const certificateRef = useRef();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // ✅ Backend URL
  const BASE_URL = "https://vs-certificate.onrender.com";
  const handleDownload = async () => {
    if (!certificateRef.current) return;

    setLoading(true);
    setMessage("");

    try {
      // Give time for images/fonts to load
      await new Promise((res) => setTimeout(res, 500));

      // Capture the DOM as canvas
      const canvas = await html2canvas(certificateRef.current, {
        scale: 2,        // increase resolution
        useCORS: true,   // allows cross-origin images
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("landscape", "pt", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${employeeName || "certificate"}.pdf`);

      setMessage("✅ Certificate downloaded successfully!");
    } catch (err) {
      console.error("PDF generation failed:", err);
      setMessage("❌ Failed to generate PDF.");
    } finally {
      setLoading(false);
    }
  };
//   const handleDownload = () => {
//   const url = `http://localhost:5000/api/certificates/download/${certificateId}`;
//   window.open(url, "_blank"); 
// };

  
  // const handleDownload = async () => {

  //   if (!certificateRef.current) return;

  //   setLoading(true);
  //   setMessage("");

  //   try {
  //     const res = await axios.post(`http://localhost:5000/api/certificates`, {
  //       employeeName,
  //       course,
  //       startDate,
  //       endDate,
  //       certificateId,
  //       cinId,
  //     });

  //     if (res.data.success) {
  //       setMessage("✅ Certificate record saved successfully!");
  //     } else {
  //       setMessage("⚠️ Could not save certificate record, but proceeding with download.");
  //     }

  //     // ✅ Step 2: Convert certificate DOM to PDF
  //     await new Promise((res) => setTimeout(res, 800)); // small delay for rendering
  //     const canvas = await html2canvas(certificateRef.current, {
  //       scale: 2,
  //       useCORS: true,
  //     });

  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("landscape", "pt", "a4");
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  //     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //     pdf.save(`${employeeName || "certificate"}.pdf`);
  //   } catch (err) {
  //     console.error("PDF generation or save failed:", err);
  //     setMessage("❌ Failed to connect to backend or generate PDF.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <div className="certificate-wrapper">
      <div
        ref={certificateRef}
        className="certificate-card"
        style={{
          backgroundImage: `url(/certificate-template.png)`,
        }}
      >
        <div className="certificate-content">
          <h1 className="cert-title">CERTIFICATE</h1>
          <h2 className="cert-subtitle">of Completion</h2>
          <h4 className="cert-text">This certificate is proudly presented to</h4>
          <h3 className="cert-name">{employeeName}</h3>

          <div className="cert-body">
            <p>
              We are happy to certify that <strong>{employeeName}</strong> has
              successfully completed their internship as a{" "}
              <strong>“{course}”</strong>.
            </p>
            <p>
              The internship period was from <strong>{startDate}</strong> to{" "}
              <strong>{endDate}</strong>.
            </p>
            <p>We appreciate their valuable work and contribution.</p>
          </div>
        </div>

        {/* Certificate IDs */}
        <div className="cert-footer">
          <p>
            <strong>Certificate ID:</strong> {certificateId}
          </p>
          <p>
            <strong>CIN ID:</strong> {cinId}
          </p>
        </div>
      </div>

      {/* Download Button */}
      <button onClick={handleDownload} disabled={loading} className="download-btn">
        {loading ? "Generating..." : "Download Certificate"}
      </button>

      {/* Status message */}
      {message && <p className="status-msg">{message}</p>}
    </div>
  );
};

export default Certificate;
